
  import CatalogPageView from "../../components/views/CatalogPageView";
  // import { flatten } from "../../helpers/flatten";

  export default {
    name: "CatalogPage",
    components: { CatalogPageView },
    // layout: "default",

    async fetch() {
      await this.$store.dispatch("music/getMusicVarieties");
      await this.$store.dispatch("music/getGenres");
      await this.$store.dispatch("music/getMoods");
      await this.$store.dispatch("music/getThemes");
      await this.$store.dispatch("music/getInstruments");
      await this.$store.dispatch("music/getTempos");
      await this.$store.dispatch("music/getTonalities");
      await this.$store.dispatch("music/getMainKeys");

      await this.$store.dispatch("tracks/getTrackList", this.$route.query);
    },

    // async mounted() {
    //   // TODO: сделать фасет для длины
    //   const queryObj = Object.entries(this.$route.query);
    //   const newQuery = queryObj.map(([key, value]) => {
    //     return value.split(",").map(v => `selected_facets=${key}_exact:${v}`);
    //   });
    //   const linkFacets = flatten(newQuery).join("&");
    //   await this.$store.dispatch("music/getCountTracksFilters", linkFacets);
    // }
  };
